const errTxt = ({ err }) => (err?.length && Array.isArray(err) && err[0] ? err[0] : err || '')

export default errTxt
